<template>
  <div class="container">

    <div class="seraw_box">
      <el-input v-model="query.name" style="width:200px" clearable placeholder="收款码名称" @input="inputone" />
      <el-button type="primary" style="margin-left:10px" icon="el-icon-search" @click.stop="sercah">搜索</el-button>
      <el-button type="primary" style="width:80px;margin-left:10px" @click.stop="additemw">添加</el-button>
      <el-button type="primary" style="width:80px" @click.stop="wecharclick">微信</el-button>
    </div>

    <div ref="main" class="link_box">
      <el-table
        class="tab_box"
        :data="tableData"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="id"
          align="center"
          label="ID"
          width="50"
        />
        <el-table-column
          prop="name"
          align="center"
          label="收款码名称"
          width="180"
        />
        <el-table-column
          prop="principal"
          align="center"
          label="负责人"
          width="180"
        />
        <el-table-column
          prop="phone"
          align="center"
          label="电话"
          width="180"
        />
        <el-table-column
          prop="qrcode_url"
          align="center"
          label="收款码"
          width="300"
        >
          <template scope="scope">
            <img :src="scope.row.qrcode_url" class="pic_img" alt="" @click="lookpic(scope.row.qrcode_url)">
          </template>
        </el-table-column>
        <el-table-column
          prop="qrcode_url"
          align="center"
          label="状态"
          width="130"
        >
          <template scope="scope">
            <el-tag v-if="scope.row.work_status === 1" type="success">{{ scope.row.work_status_str }}</el-tag>
            <el-tag v-if="scope.row.work_status === 2" type="danger">{{ scope.row.work_status_str }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="work_time"
          align="center"
          label="正常时间"
          width="180"
        />
        <el-table-column
          prop="err_time"
          align="center"
          label="异常时间"
          width="180"
        />
        <el-table-column
          align="center"
          prop="work_status"
          label="操作"
        >
          <template scope="scope">
            <el-button type="primary" size="mini" @click="edit(scope.row)">编辑</el-button>
            <el-button type="primary" size="mini" @click="deleterr(scope.row.id)">删除</el-button>
            <el-button type="primary" size="mini" @click="paylist(scope.row.id)">支付记录</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <br>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog
      :title="status === 1 ? '新增' : '编辑'"
      :visible.sync="dialogVisible"
      width="30%"
      :close-on-click-modal="false"
      @close="handleclose"
    >
      <div class="reform">
        <div>
          收款码：
        </div>
        <div>
          <el-input v-model="paymentcode" style="width:330px" placeholder="收款码名称" />
        </div>
      </div>
      <div class="reform">
        <div>
          负责人：
        </div>
        <div>
          <el-input v-model="principal" style="width:330px" placeholder="负责人" />
        </div>
      </div>
      <div class="reform">
        <div>
          手机号：
        </div>
        <div>
          <el-input v-model="phone" style="width:330px" placeholder="手机号" maxlength="11" />
        </div>
      </div>

      <button class="button upload inrew" @click="$refs.file.click()">
        <i class="icon" />
        <span>上传文件</span>
        <input ref="file" type="file" class="file" @change="myChange">
      </button>
      <br>
      <img :src="imgSrc" class="brand-img">
      <span slot="footer" class="dialog-footer">
        <el-button v-if="status === 1" type="primary" @click="sunbimtit">确 定</el-button>
        <el-button v-if="status === 2" type="primary" @click="editsunbimtit">修改</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="查看"
      :visible.sync="lookdialogVisible"
      width="30%"
    >
      <div style="text-align:center">
        <img :src="imgSrcbig" alt="" class="bigpic">
      </div>

    </el-dialog>
    <el-drawer
      title="我是标题"
      :visible.sync="drawer"
      :with-header="false"
      @close="resrist"
    >
      <viewbigpicture ref="viewbig" />
    </el-drawer>

    <el-dialog
      title="交易记录"
      :visible.sync="paydialogVisible"
      width="60%"
    >
      <payrecorddialog ref="paydialog" />
    </el-dialog>
  </div>

</template>

<script>
import * as qiniu from 'qiniu-js'
import { qiniuToken } from '@/api/qiniuToken'
import { wechatpay, payrlist, deletepay, wechatunable } from '@/api/providerAccountManagement/servicePorviderList.js'
import viewbigpicture from './components/viewbigpicture.vue'
import payrecorddialog from './components/payrecorddialog.vue'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  name: 'UploadBrandImageDialog',
  components: {
    viewbigpicture,
    payrecorddialog,
    PaginationRight
  },
  data() {
    return {
      lookdialogVisible: false,
      paydialogVisible: false,
      drawer: false,
      imgSrcbig: null,
      imgSrc: null,
      dialogVisible: false,
      paymentcode: '',
      principal: '',
      phone: '',
      qrcode_url: '',
      query: {
        page: 1,
        page_size: 10,
        name: null
      },
      tableData: [],
      id: null,
      status: null,
      total: null
    }
  },
  created() {
    this.getQiniuToken()
    this.getpaylist()
  },
  methods: {
    getQiniuToken() {
      qiniuToken().then(res => {
        this.token = res.data.uptoken
      })
    },
    additemw() {
      this.dialogVisible = true
      this.status = 1
    },
    handleclose() {
      this.paymentcode = ''
      this.principal = ''
      this.phone = ''
      this.qrcode_url = ''
      this.imgSrc = null
      console.log('重置')
    },
    async sunbimtit() {
      const reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
      if (this.paymentcode === '') {
        this.$message.error('请填写收款码名称')
        return
      }
      if (this.principal === '') {
        this.$message.error('请填写负责人')
        return
      }
      if (!reg_tel.test(this.phone)) {
        this.$message.error('请填写正确的电话')
        return
      }
      if (this.qrcode_url === '') {
        this.$message.error('请上传图片')
        return
      }
      const data = await wechatpay({
        name: this.paymentcode,
        principal: this.principal,
        phone: this.phone,
        qrcode_url: this.qrcode_url
      })
      this.$message({
        message: '新增成功',
        type: 'success'
      })
      this.dialogVisible = false
      this.getpaylist()
      console.log('data', data)
    },
    async editsunbimtit() {
      const reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
      const id = this.id
      const name = this.paymentcode
      const principal = this.principal
      const phone = this.phone
      const qrcode_url = this.qrcode_url
      if (this.paymentcode === '') {
        this.$message.error('请填写收款码名称')
        return
      }
      if (this.principal === '') {
        this.$message.error('请填写负责人')
        return
      }
      if (!reg_tel.test(this.phone)) {
        this.$message.error('请填写正确的电话')
        return
      }
      if (this.qrcode_url === '') {
        this.$message.error('请上传图片')
        return
      }
      const data = await wechatunable(id, name, principal, phone, qrcode_url)
      this.$message({
        message: '修改成功',
        type: 'success'
      })
      this.dialogVisible = false
      this.getpaylist()
      console.log('data', data)
    },
    // 获取列表
    async getpaylist() {
      const data = await payrlist(this.query)
      console.log(data)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('列表数据', data)
    },
    // 分页
    fetchPageSize(e) {
      this.query.page_size = e
      this.getpaylist()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.getpaylist()
    },
    lookpic(img) {
      this.lookdialogVisible = true
      this.imgSrcbig = img
    },
    myChange(event) {
      // const sizemb = (event.target.files[0].size / 1024).toFixed(3)
      // const size = size / 1024// kb
      // size = (size / 1024).toFixed(3)// mb
      const file = event.target.files[0] // 文件信息对象
      // if (file.size > 400000) {
      //   this.$message({
      //     message: '图片必须小于50kb',
      //     type: 'error'
      //   })
      //   return
      // }
      // // 判断是否符合尺寸条件
      // this.isLimitSize(file, 512, 512).then(res => {
      //   this.randomName(file)
      // })

      this.randomName(file)
    },
    // 随机生成图片名称后上传
    randomName(file) {
      const url = window.URL.createObjectURL(file)
      const fsuiji = Math.random().toString(36).slice(-4) // 随机4位字符串
      const ftype = file.name.substr(file.name.lastIndexOf('.')) // 截取文件格式
      const fname = file.name.substring(0, file.name.lastIndexOf('.')) // 截取文件名
      const timeStamp = new Date() - 0 // 时间戳
      this.isUpload = true
      this.temporaryAddress = url
      this.uploadFile({
        file,
        fileName: 'user/' + fname + '_' + timeStamp + '_' + fsuiji + ftype, // 组合随机文件名
        token: this.token,
        putExtra: {
          fname: file.name // 文件名
        },
        config: {
          useCdnDomain: true // cdn域名加速
        }
      })
    },
    // 上传文件
    uploadFile({ file, fileName, token, putExtra = {}, config = {}}) {
      const vm = this
      const observable = qiniu.upload(file, fileName, token, putExtra, config)
      const subscription = observable.subscribe({
        next() {},
        error(err) {
          console.log(err, '====')
        },
        complete: (data) => {
          const sizekb = Math.ceil(file.size / 1024)
          // const type = file.type
          const img = new Image()
          img.src = window.URL.createObjectURL(file)
          img.onload = function() {
            const query = {
              width: img.width,
              height: img.height,
              size: sizekb,
              type: 1,
              key: data.key
            }
            console.log('img.src', img.src, data.key, query)
            vm.imgSrc = img.src
            vm.qrcode_url = data.key
            // vm.brandImageParams.file = query.key
          }
        }
      }) // 上传开始
      return subscription.unsubscribe // 返回一个取消上传的方法
    },
    async deleterr(id) {
      const data = await deletepay(id)
      console.log(data)
      this.$message({
        message: '删除成功',
        type: 'success'
      })
      this.getpaylist()
    },
    edit(item) {
      this.id = item.id
      this.imgSrc = item.qrcode_url
      this.paymentcode = item.name
      this.principal = item.principal
      this.phone = item.phone
      this.qrcode_url = item.qrcode_url_key
      this.status = 2
      this.dialogVisible = true
      //      imgSrc: null,
      // paymentcode: '',
      // principal: '',
      // phone: '',
      // qrcode_url: '',
      console.log('item', item)
    },
    async paylist(id) {
      this.paydialogVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.paydialog.customeoncallback(id)
      }, 100)
    },
    resrist() {
      console.log('清空')
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.viewbig.resback()
      }, 100)
    },
    wecharclick() {
      this.drawer = true
      // setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
      //   this.$refs.viewbig.updatawechat()
      // }, 100)
    },
    sercah() {
      this.getpaylist()
    },
    inputone() {
      console.log('666')
      if (this.query.name === '') {
        this.query.name = null
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 20px;
    .brand-img {
      width: 100px;
    }
  }
  .button {
    margin-right: 16px;
    box-sizing: border-box;
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    height: 32px;
    padding: 0 15px;
    font-size: 14px;
    border-radius: 2px;
    border: 1px solid #e8e8e8;
    &.upload {
      color: #fff;
      background-color: #00aae7;
      border-color: #00aae7;
      cursor: pointer;
      &:hover {
        color: #fff;
        background-color: #36d2f6;
        border-color: #36d2f6;
      }
    }

    &.batch {
      color: #bfbfbf;
      background-color: #fff;
      border-color: #d9d9d9;
      text-shadow: none;
      box-shadow: none;
      cursor: no-drop;
    }

    &.refresh {
      line-height: 32px;
      color: #595959;
      background-color: #fff;
      border-color: #bfbfbf;
      cursor: pointer;
      &:hover {
        color: #00aae7;
        background-color: #fff;
        border-color: #26b7ea;
      }
    }

    .icon {
      &.upload {
        &::after {
          content: "\e61b";
        }
      }

      &.batch {
        &::after {
          content: "\e772";
        }
      }

      &.refresh {
        &::after {
          content: "\ec08";
        }
      }
    }
    .file {
      display: none;
    }
    .icon {
      font-style: normal;
      font-family: "el-icon-upload2";
    }
  }
  .tab_box{
    margin-top: 10px;
  }
  .inrew{
    margin-bottom: 10px;
  }
  .pic_img{
    width: 95px;
    height: 125px;
  }
  .bigpic{
    width: 290px;
    height: 400px;
  }
   /deep/ .el-drawer.rtl{
    width: 40% !important;
   }
   .link_box{
  max-height: 750px;
  overflow: auto;
}
.link_box::-webkit-scrollbar{ /*滚动条整体样式*/
    width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
}
.link_box::-webkit-scrollbar-thumb{ /*滚动条里面小方块*/
    border-radius: 10px;
    background: #cfcbcb;
}
.link_box::-webkit-scrollbar-track{ /*滚动条里面轨道*/
    border-radius: 10px;
    background: #ededed;
}
.reform{
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.seraw_box{
    display: flex;
  align-items: center;
}
</style>
